import {
    FETCH_TRAITS_SUCCESS,
    FETCH_STORE_TRAITS_SUCCESS,
    TRAITS_REQUEST_LOADING,
    TRAITS_REQUEST_ERRORS
} from "api/menu/master-files/traits/actions";

const initialState = {
    loading: false,
    errors: [],

    jobTraits: [],
    storeTraits: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case TRAITS_REQUEST_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case TRAITS_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_TRAITS_SUCCESS:
            return {
                ...state,
                loading: false,
                jobTraits: action.payload
            };
        case FETCH_STORE_TRAITS_SUCCESS:
            return {
                ...state,
                loading: false,
                storeTraits: action.payload
            };
        default:
            return state;
    }
}
